module.exports = __webpack_public_path__ + "static/small-cards-f49879300a8f8902ae5b2319565c3325.png";